// extracted by mini-css-extract-plugin
module.exports = {"scrollBody":"style_scrollBody__gMWqF"};